import React from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';

// css
import './BuscarPage.css'; // Seu CSS customizado
import 'bootstrap/dist/css/bootstrap.min.css';  // Importando o CSS do Bootstrap
import '../../styles/global.css';

const BuscarPage = () => {
  return (
    <div className="buscar-container">
      <TituloComponent /> {/* Adiciona o título fixo no topo */}

      <div>
        <h2>Buscar</h2>
        {/* Conteúdo da página de Buscar */}
      </div>
    </div>
  );
};

export default BuscarPage;
